import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Modal from '@ublique/components/LoadingModal'
import Loading from '@ublique/components/Loading'

import DefaultForm from './DefaultForm'

import useStoreSelector from 'utils/hooks/useStoreSelector'

import {
  handleFormFields,
  buildPayloadByType,
  processSubmitErrors,
  getModalName
} from '../helpers'
import { sendNotification } from './Notification'

import { addNewTranslation } from 'services/api/translations'

const defaultValues = {
  path: ''
}

const NewTranslation = ({ open, close, allLanguages }) => {
  const { t } = useTranslation('Common')
  const [newValue, setNewValue] = useState(defaultValues)
  const [isLoading, setIsLoading] = useState(false)
  const { modalsData } = useStoreSelector('modal')

  const { type, group, subgroup, onSubmit } = modalsData.newTranslation

  const handleSubmit = async () => {
    const notification = { t, action: 'create', info: type }
    const payload = buildPayloadByType(
      newValue,
      type,
      group,
      subgroup,
      allLanguages
    )
    setIsLoading(true)
    try {
      await addNewTranslation(payload)

      sendNotification({
        ...notification,
        kind: 'success',
        title: t('Translations:IMPORT')
      })
    } catch (err) {
      console.error(err)
    }
    setIsLoading(false)

    if (onSubmit) onSubmit()

    return close()
  }

  const handleOnAddChange = useCallback(
    (value) => {
      setNewValue((prevState) => ({ ...prevState, ...value }))
    },
    [newValue]
  )
  const getErrors = useCallback(() => {
    return processSubmitErrors(newValue.path, type, subgroup)
  }, [newValue.path, type, subgroup])

  return (
    <Modal
      height='475px'
      open={open}
      onRequestClose={close}
      onRequestSubmit={handleSubmit}
      modalHeading={t(getModalName(type))}
      primaryButtonText={t('Save')}
      secondaryButtonText={t('Cancel')}
      primaryButtonDisabled={!newValue.path || getErrors()}
      preventCloseOnClickOutside
    >
      {isLoading && <Loading description='Loading' withOverlay />}
      <DefaultForm
        formFields={handleFormFields(
          handleOnAddChange,
          newValue,
          type,
          subgroup,
          allLanguages
        )}
        t={t}
      />
    </Modal>
  )
}

export default NewTranslation
